<template>
  <div class="page-break">
    <el-row>
      <el-col :span="24">
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">
          {{ topData[0].SUPPLIER_NAME }}送货单
        </h1>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0px;" :style="{ height: Number(form.lookUp.length) == 0 ? '0px' : '' }">
      <el-col :span="24">
        <ul style="margin-top: 10px; display: flex; flex-wrap: wrap;">
          <li><span>项目点</span>:{{ topData[0].PROJECT_NAME }}</li>
          <li><span>供应商</span>:{{ getSupplier() }}</li>
          <li><span>送货日期</span>:{{ topData[0].SEND_DAY }}</li>
          <li><span>回单日期</span>:</li>
          <li><span>档口</span>:{{ topData[0].DK_NAME }}</li>
          <li><span>制单人</span>:{{ managername }}</li>
          <li><span>订单编号</span>:{{ topData[0].ORDER_CODE }}</li>
          <li>
            <span>总金额</span>:{{ topData[0].TOTAL_PROJECT_FEE }}
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" style="position:relative;">
        <table style="width: 100%">
          <tr>
            <th style="width: 40px;">序号</th>
            <th>名称</th>
            <th style="width: 40px;">单位</th>
            <th style="width: 90px;">订购数量</th>
            <!-- <th style="width: 10%">实收数量</th> -->
            <th style="width: 90px;">单价</th>
            <th style="width: 100px;">订购总金额</th>
            <th style="width: 90px;">备注</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td>{{ item.PRODUCT_NAME }}</td>
            <td>{{ item.TYPE_UNIT }}</td>
            <td>{{ item.PRODUCT_COUNT }}</td>
            <!-- <td></td> -->
            <td>{{ item.PROJECT_PRICE }}</td>
            <td>{{ (Number(item.PROJECT_PRICE) * Number(item.PRODUCT_COUNT)).toFixed(2) }}</td>
            <td>{{ item.PRODUCT_COMMENT }}</td>
          </tr>
        </table>
      </el-col>
      <div style="position: absolute; right: 6%; display: flex; flex-direction: column; font-size: 0;">
        <!-- <div :class="index"> -->
        <span :style="changeStyle(index)" style="font-size: 15px;" v-for="(item, index)  in address" :key="index">
          {{ item }}
        </span>
      </div>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="6">
        <span>本页金额：{{ mainData[0].pageFee }}</span>
      </el-col>
      <el-col :span="5">
        <span>项目经理：{{ accociated_person[0].MANAGER_NAME }}</span>
      </el-col>
      <el-col :span="5">
        <span>厨师长：</span>
      </el-col>
      <el-col :span="5">
        <span>验收人员：</span>
      </el-col>
    </el-row>
    <el-row v-if="isShortDocFlag == 2">
      <el-col :span="3" :offset="20" style="padding: 0">
        <p>第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  projectList,
} from 'api/customerManage';
import http from '@/assets/common/http';

export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      showCode: 0,
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    ASSOCIATED_PERSON: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    isRemarks: {
      type: Number,
      default() {
        return 1;
      },
      required: true,
    },
    manager: String,
    supplier: String,
  },
  data() {
    return {
      topData: [],
      mainData: [],
      managername: '',
      imgUrl: '',
      printSupplier: '',
      ORDER_TC_ID: sessionStorage.getItem('ORDER_TC_ID') || '',
      supplierNameStatus: Number(sessionStorage.getItem('supplierNameStatus')),
      sinceStatus: Number(sessionStorage.getItem('sinceStatus')),
      companyName: sessionStorage.getItem('name'),
      printName: sessionStorage.getItem('supplierName'),
      payableName: sessionStorage.getItem('name'),
      payableName1: '',
      countFlag: sessionStorage.getItem('countFlag'),
      printRealFlag: 0,
      NEED_tcName: sessionStorage.getItem('NEED_TCNAME'),
      payableForm: {},
      form: {
        TEMPLATE_TYPE: 1,
        lookUpMessage: '',
        supplierName: sessionStorage.getItem('name'),
        address: '',
        tableSet: [

        ],
        checked3: false,
        lookUp: [
        ],
        footerSet: [],
        TYPE: '1',
      },
      isShortDocFlag: 2,
      showProject: 0,
      showCode: 0,
      showDK: 0,
      showSupplier: 0,
      Distribution: 0,
      receiving: 0,
      entrust: 0,
      showSendDay: 0,
      voucher: 0,
      contactPerson: 0,
      orderCode: 0,
      showprojectAddress: 0,
      showReceipt: 0,
      showProductCode: 0,
      showDeliveryCount: 0,
      showOrderCount: 0,
      showShort: 0,
      showBRAND: 0,
      showSPE: 0,
      showPaidCount: 0,
      showPrice: 0,
      showAllFee: 0,
      showSongAllFee: 0,
      showDingAllFee: 0,
      showShiAllFee: 0,
      showComent: 0,
      showProduction: 0,
      showShelf: 0,
      deliveryMember: 0,
      showDeliveryPersonnel: 0,
      deliveryTime: 0,
      deliveryAddress: 0,
      acceptanceTime: 0,
      acceptancePerson: 0,
      showChef: 0,
      showManager: 0,
      showAmountPage: 0,
      printRealFlagAll: 0,
      address: [],
      totalNum: '',
      SUPPLIER_NAME77: '上海内航餐饮服务有限公司(永和食品)',
      projectSitesListData: '',
      accociated_person: [],
      basketInfo: [],
      showOrderComment: false,
    };
  },
  created() {
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.accociated_person = this.ASSOCIATED_PERSON;
    this.printSupplier = this.supplier;
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;

    // this.queryForm();
  },
  beforeDestroy() {
    sessionStorage.removeItem('sinceStatus');
  },

  methods: {
    changeStyle(index) {
      if (index % 4 == 0) {
        return { 'margin-top': '5px' };
      }
    },
    getSupplier() {
      if (this.topData[0].PROJECT_NAME == '上海华为') {
        if (this.SUPPLIER_NAME77.indexOf('上海内航餐饮服务有限公司(') !== -1) {
          const index1 = this.SUPPLIER_NAME77.indexOf('(');
          const index2 = this.SUPPLIER_NAME77.indexOf(')');
          return this.SUPPLIER_NAME77.substring(index1 + 1, index2);
        }
        return this.topData[0].SUPPLIER_NAME;
      }
      return this.topData[0].SUPPLIER_NAME;
    },
    getPROJECT(e) {
      e = e.replace('联系人：', '').replace('联系人:', '');
      if (e) {
        return e;
      }
      const data = {
        TC_ID: sessionStorage.getItem('TEM_TCID'),
        STATUS: -1,
        PAGESIZE: 100000,
        PAGEINDEX: 0,
        ADD_POINT: '0.00',
      };
      this.loadSearch = true;
      projectList(data).then((res) => {
        if (res) {
          if (res[0].list[0].MANAGER_NAME) {
            this.projectSitesListData = `${res[0].list[0].MANAGER_NAME}`;
            this.totalNum = res[0].list[0].MANAGER_CELLPHONE;
          } else {
            this.contactPerson = 0;
          }
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.loadSearch = false;
      });
      return `${this.projectSitesListData}${this.totalNum}`;
    },
    queryForm() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        TC_ID: sessionStorage.getItem('TEM_TCID'),
        IS_SUPPLIER_CLIENT: 0,
      };
      http.post(params).then((result) => {
        if (result[0].TEMPLATE_CONTENT.length !== 0) {
          result[0].TEMPLATE_CONTENT.map((item) => {
            if (item.TEMPLATE_TYPE == 1) {
              this.form = item;
              this.form.TYPE = String(item.TYPE);
              if (item.checked3 == 0) {
                this.form.checked3 = false;
              } else {
                this.form.checked3 = true;
              }
            }
          });
        }
        this.judgment();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    judgment() {
      if (this.form.lookUpMessage) {
        this.payableName = this.form.lookUpMessage;
      }
      if (this.form.supplierName) {
        this.payableName1 = this.form.supplierName;
      }
      if (this.form.checked3) {
        this.showCode = 1;
      }
      if (this.form.basketSet) {
        this.basketInfo = this.form.basketSet;
      }
      this.form.lookUp.forEach((item) => {
        if (item == '项目点') {
          this.showProject = 1;
        }
        if (item == '档口') {
          this.showDK = 1;
        }
        if (item == '供应商') {
          this.showSupplier = 1;
        }
        if (item == '配送方') {
          this.Distribution = 1;
        }
        if (item == '收货方') {
          this.receiving = 1;
        }
        if (item == '委托方') {
          this.entrust = 1;
        }
        if (item == '送货日期') {
          this.showSendDay = 1;
        }
        if (item == '制单人') {
          this.voucher = 1;
        }
        if (item == '联系人') {
          this.contactPerson = 1;
        }
        if (item == '订单编号') {
          this.orderCode = 1;
        }
        if (item == '项目点地址') {
          this.showprojectAddress = 1;
        }
        if (item == '回单日期') {
          this.showReceipt = 1;
        }
        if (item == '总金额') {
          this.printRealFlagAll = 1;
        }
        if (item == '订单备注') {
          this.showOrderComment = true;
        }
      });
      this.form.tableSet.forEach((item) => {
        if (item == '产品编码') {
          this.showProductCode = 1;
        }
        if (item == '订购数量') {
          this.showOrderCount = 1;
        }
        if (item == '使用短名') {
          this.showShort = 1;
        }
        if (item == '品牌') {
          this.showBRAND = 1;
        }
        if (item == '规格') {
          this.showSPE = 1;
        }
        if (item == '送货数量') {
          this.showDeliveryCount = 1;
        }

        if (item == '实收数量') {
          this.showPaidCount = 1;
        }
        if (item == '价格') {
          this.showPrice = 1;
        }
        if (item == '送货总金额') {
          this.showSongAllFee = 1;
          this.printRealFlag = 2;
        }
        if (item == '订购总金额') {
          this.showDingAllFee = 1;
          this.printRealFlag = 1;
        }
        if (item == '实收总金额') {
          this.showShiAllFee = 1;
          this.printRealFlag = 3;
        }
        if (item == '备注') {
          this.showComent = 1;
        }
        if (item == '加工/生产日期') {
          this.showProduction = 1;
        }
        if (item == '保质期') {
          this.showShelf = 1;
        }
      });
      this.form.footerSet.forEach((item) => {
        if (item == '发货人员') {
          this.deliveryMember = 1;
        }
        if (item == '送货人员') {
          this.showDeliveryPersonnel = 1;
        }
        if (item == '发货时间') {
          this.deliveryTime = 1;
        }
        if (item == '送货路线') {
          this.deliveryAddress = 1;
        }
        if (item == '验收时间') {
          this.acceptanceTime = 1;
        }
        if (item == '验收人员') {
          this.acceptancePerson = 1;
        }
        if (item == '厨师长') {
          this.showChef = 1;
        }
        if (item == '项目经理') {
          this.showManager = 1;
        }
        if (item == '本页金额') {
          this.showAmountPage = 1;
        }
      });
      this.address = this.form.address.split('').filter((i) => i && i.trim());
    },
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 20px;
  line-height: 20px;
  color: #000;
  font-family: 黑体;
  width: 50%;
}

span {
  font-size: 20px;
  line-height: 20px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
  table-layout: fixed;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 20px;
  height: 20px;
  font-family: 黑体;
  color: #000;
  /* white-space:nowrap;overflow:hidden;text-overflow:ellipsis; */
  white-space: nowrap;
  /* 因为设置了block，所以需要设置nowrap来确保不换行*/
  /* 超出隐藏结合width使用截取采用效果 */
  overflow: hidden;
  text-overflow: ellipsis;
  /* 本功能的主要功臣，超出部分的剪裁方式 */
  -o-text-overflow: ellipsis;
  /* 特定浏览器前缀 */
  text-decoration: none;
}

li span {
  display: inline-block;
  width: 110px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/selfOrderPrintBySequenceTax.vue